import * as React from 'react';
import { connect } from 'react-redux';
import * as  apiService from '../../store/apiService';

// header
import Header from '../../sharedcomponents/header';

// loading
import { Loader } from '../../sharedcomponents/loader';
// actions
import { fetchProductionSpeedReports, fetchSalesRepData } from '../../store/productionSpeed/actions'

// logout
import { logout } from '../../store/login/action'

// devextremene grid
import {
  SearchState,
  FilteringState,
  IntegratedFiltering,
  PagingState,
  SortingState,
  CustomPaging,
  IntegratedPaging,
  IntegratedSorting,
} from '@devexpress/dx-react-grid';
import Paper from '@material-ui/core/Paper';
import {
  Grid,
  Table,
  Toolbar,
  SearchPanel,
  TableHeaderRow,
  TableFilterRow,
  PagingPanel,
  TableColumnVisibility,
  ColumnChooser,

} from '@devexpress/dx-react-grid-material-ui';

// material ui date date range picker
import { sortDatebySelection, sortNumber, sortCurrency } from '../../helpers/sortingHelper';

// @ts-ignore
const ColumnCell = ({ getMessage, column, ...restProps }) => (
  // @ts-ignore
  <TableHeaderRow.Cell
    column={column}
    getMessage={() => column.title}
    {...restProps}
  />
);

// @ts-ignore
const DataCell = ({ value, ...restProps }) => {
  // @ts-ignore
  const { column } = restProps;
  // @ts-ignore
  if (column.name === 'revenueColumn') {
    return <td className="text-right paddingright40">${parseFloat(restProps.row.revenue).toLocaleString(undefined, { minimumFractionDigits: 2 })}</td>
  } else if (column.name === 'prop_num') {
    return <td><div><a style={{ color: 'lightblue' }} onClick={() => handleClickRowEdit(restProps.row.prop_num)}><i className="fa fa-trash-alt"></i>{restProps.row.prop_num}</a></div></td>
  } else {
    // @ts-ignore
    return <Table.Cell {...restProps}>
      <span title={value}>{value}</span>
    </Table.Cell>
  }
}

const handleClickRowEdit = (args: any) => {
  window.open(apiService.atlaslink(args), "_blank")
}

class productionSpeed extends React.PureComponent<any, any>  {
  public changeCurrentPage: any; public changePageSize: any;
  constructor(props: any) {
    super(props);
    this.state = {
      route: '',
      date: '',
      selectedSalesPerson: 'all',
      selectedYear: new Date().getFullYear().toString(),
      selectedMonth: new Date().getMonth().toString(),
      listSalesPerson: [],
      columns: [
        { name: 'prop_num', title: 'pNum' },
        { name: 'client_name', title: 'SHIPPED' },
        { name: 'encl_ship_date', title: 'Encl ShipDate' },
        { name: 'sale_date', title: 'PC SaleDate' },
        { name: 'speed', title: 'Speed' }, // values caluclating at reducer (Difference in days between pc.sale_date and pc.encl_ship_date)
        { name: 'salesperson', title: 'SalesRep' },
        { name: 'csm', title: 'CSM' },
        { name: 'production', title: 'ProdRep' },
        { name: 'revenueColumn', title: 'Revenue' }
      ],
      rows: [],
      sorting: [{ columnName: 'UserName', direction: 'asc' }],
      totalCount: 0,
      pageSize: 10,
      pageSizes: [10, 15, 30, 50],
      integratedSortingColumnExtensions: [
        { columnName: 'encl_ship_date', compare: sortDatebySelection },
        { columnName: 'sale_date', compare: sortDatebySelection },
        { columnName: 'prop_num', compare: sortNumber },
        { columnName: 'revenueColumn', compare: sortCurrency }
      ],
    };

    this.changeSorting = this.changeSorting.bind(this);
    this.changeCurrentPage = (currentPage: any) => this.setState({ currentPage });
    this.changePageSize = (pageSize: any) => this.setState({ pageSize });
    this.Sessionlogout = this.Sessionlogout.bind(this)
  }

  public Sessionlogout() {
    this.props.dispatch(logout());
  }

  public componentWillMount() {
    this.props.dispatch(fetchSalesRepData())
  }

  public componentDidMount() {
    this.props.dispatch(fetchProductionSpeedReports(this.state.selectedYear, this.state.selectedMonth, this.state.selectedSalesPerson));
  }

  public componentDidUpdate() {
    if (this.props.ProductionSpeedReportData) {
      this.setState({
        rows: this.props.ProductionSpeedReportData.data
      })
    }
  }

  public componentWillReceiveProps(props: any) {
    const SalesRepList = props.SalesRep;
    if (SalesRepList) {
      Object.keys(SalesRepList.salesperson).map(key => {
        if (SalesRepList.salesperson[key].emp_name !== '') {
          this.state.listSalesPerson.push(<option key={SalesRepList.salesperson[key].sales_id} value={SalesRepList.salesperson[key].salesperson}>{SalesRepList.salesperson[key].salesperson}</option>)
        }
      }
      );
    }
  }

  public changeSorting(sorting: any) {
    this.setState({
      loading: true,
      sorting,
    });
  }

  public getFilteredYearParams(args: any) {
    if (args.target.value) {
      this.props.dispatch(fetchProductionSpeedReports(args.target.value, this.state.selectedMonth, this.state.selectedSalesPerson));
    }
    this.setState({
      selectedYear: args.target.value
    })
  }

  public getFilteredMonthParams(args: any) {
    if (args.target.value) {
      this.props.dispatch(fetchProductionSpeedReports(this.state.selectedYear, args.target.value, this.state.selectedSalesPerson));
    }
    this.setState({
      selectedMonth: args.target.value
    })
  }

  public getFilteredSalesRepParams(args: any) {
    if (args.target.value) {
      this.props.dispatch(fetchProductionSpeedReports(this.state.selectedYear, this.state.selectedMonth, args.target.value));
    }
    this.setState({
      selectedSalesPerson: args.target.value
    })
  }

  public render() {
    const loading = this.props.loading ? <Loader /> : '';
    let aggrData;
    const yearDropdown = []
    if (this.props.ProductionSpeedReportData){
      aggrData = this.props.ProductionSpeedReportData.aggrData;
      const yearList = aggrData.yearArray;
      for (const year of yearList) {
        yearDropdown.push(<option key={year} value={year}>{year}</option>)
      }
    }

    const aggrDataDiv =
      this.props.ProductionSpeedReportData !== undefined ?
        <div id="productionFields_info">
          <div className="production_reports">
            <span><b>Total Revenue:-</b> ${aggrData.totalRevenue.toLocaleString(undefined, { minimumFractionDigits: 2 })}</span> <br />
            <span><b>Total Units:-</b> {aggrData.totalUnit} Units</span> <br />
            <span><b>Average Turnaround:-</b> {aggrData.avgSpeed} Days</span>
          </div>
          <div className="production_speed_reports">
            <span><b>Sold Same Month : </b> {aggrData.curruntMonthUnits} / ${aggrData.currentMonthRevenue.toLocaleString(undefined, { minimumFractionDigits: 2 })} - {aggrData.currentMonthUnitRatioToTotal}% / {aggrData.currentMonthRevenueRatioToTotal}%</span><br />
            <span><b>Sold Prev Month : </b> {aggrData.prevMonthUnits} / ${aggrData.prevMonthRevenue.toLocaleString(undefined, { minimumFractionDigits: 2 })} - {aggrData.prevMonthUnitRatioToTotal}% / {aggrData.prevMonthRevenueRatioToTotal}%</span><br />
            <span><b>Sold 2 Months Prev : </b> {aggrData.twoMonthPrevUnits} / ${aggrData.twoMonthPrevRevenue.toLocaleString(undefined, { minimumFractionDigits: 2 })} - {aggrData.twoMonthPrevUnitRatioToTotal}% /{aggrData.twoMonthPrevRevenueRatioToTotal}%</span><br />
            <span><b>3 Months + :</b> {aggrData.restMonthUnits} / ${aggrData.restMonthRevenue.toLocaleString(undefined, { minimumFractionDigits: 2 })} - {aggrData.restMonthUnitRatioToTotal}% / {aggrData.restMonthRevenueRatioToTotal}%</span><br />
          </div>
          <div className="clear"></div>
        </div>
        : '';

    const {
      rows,
      columns,
      integratedSortingColumnExtensions,
      pageSize,
      pageSizes,
      currentPage,
      totalCount
    } = this.state;
    return (
      <div>
        {loading}
        <Header />
        <div className="header-bottom">
          <button
            className="btn right-float"
            onClick={() => this.Sessionlogout()}
          >Logout</button>
        </div>
        {aggrDataDiv}
        <div className="content-body">
          <div className="content-section" id="production_speed">
            <div className="grid-style">

              <div className="production-filter_select">

                <select onChange={(e) => {
                  this.getFilteredYearParams(e)
                }} value={this.state.selectedYear} >
                  <option value="all">All</option>
                  {yearDropdown}
                </select>

                <select onChange={(e) => {
                  this.getFilteredMonthParams(e)
                }} value={this.state.selectedMonth} >
                  <option value="all">All</option>
                  <option value="0">January</option>
                  <option value="1">February</option>
                  <option value="2">March</option>
                  <option value="3">April</option>
                  <option value="4">May</option>
                  <option value="5">June</option>
                  <option value="6">July</option>
                  <option value="7">August</option>
                  <option value="8">September</option>
                  <option value="9">October</option>
                  <option value="10">November</option>
                  <option value="11">December</option>
                </select>

                <select onChange={(e) => {
                  this.getFilteredSalesRepParams(e)

                }} value={this.state.selectedSalesPerson} >
                  <option value="all">All</option>
                  {this.state.listSalesPerson}
                </select>
              </div>
              <Paper className="papergrid" style={{ position: 'relative' }}>
                <Grid
                  rows={rows}
                  columns={columns}
                >
                 
                  <SearchState defaultValue="" />
                  <FilteringState defaultFilters={[]} />
                  <IntegratedFiltering />

                  <SortingState
                    // 
                    defaultSorting={[
                      { columnName: 'prop_num', direction: 'asc' }
                    ]}
                  />
                  <IntegratedSorting
                    columnExtensions={integratedSortingColumnExtensions}
                  />
                  <PagingState
                    defaultCurrentPage={0}
                    currentPage={currentPage}
                    onCurrentPageChange={this.changeCurrentPage}
                    pageSize={pageSize}
                    onPageSizeChange={this.changePageSize}
                  />
                  <CustomPaging
                    totalCount={totalCount}
                  />
                  <IntegratedPaging />
                  <Table
                    cellComponent={DataCell}
                  />
                  <TableHeaderRow
                    showSortingControls={true}
                    cellComponent={ColumnCell}
                  />
                  <TableFilterRow
                    showFilterSelector={false}
                  />
                  <TableColumnVisibility
                    defaultHiddenColumnNames={['']}
                  />
                  <Toolbar />
                  <SearchPanel />
                  <PagingPanel
                    pageSizes={pageSizes}
                  />
                  <ColumnChooser />
                </Grid>
              </Paper>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

// container
const mapStateToProps = (state: any) => ({
  ProductionSpeedReportData: state.productionSpeed.ProductionSpeedReportData,
  SalesRep: state.productionSpeed.SalesRep,
  loading: state.loading.getproductionSpeedStatus
});
export default connect(mapStateToProps)(productionSpeed);


// WEBPACK FOOTER //
// ./src/components/Production Speed/productionSpeed.tsx